module.exports = __webpack_public_path__ + "img/factory.7e440c90.svg";